module.exports = __webpack_public_path__ + "static/media/bg-discover.63c8b0d7.svg";